import {BaseModel} from "./base-model";

export class Bot extends BaseModel {

  protected static self = Bot;

  id: string;
  endpointBotId: string;
  endpointUrl: string;
  imageUrl: string;

}
